<div class="row">
  <div class="col-lg-4">
    <div class="info-list">

      <ng-container *ngIf="isFreemium || devices?.length > 0">
        <div class="d-flex info-list-item top-distribution-list">
          <div class="label">
            Top Device
          </div>
          <div class="value">
            <ng-container *ngIf="!isFreemium">
              <div class="top-item-label">{{topDevice?.deviceMarketingName}}</div>
              <div class="big-number">{{topDevice?.totalInventoryRatio | perc: '1.2-2'}}</div>
            </ng-container>
            <ng-container *ngIf="isFreemium">
              <div class="top-item-label">{{topDevice?.deviceMarketingName}}</div>
              <div class="freemium-lock">
                <i class="fa fa-lock"></i>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="isFreemium || regions?.length > 0">
        <div class="divider mt-32px mb-24px"></div>
        <div class="d-flex info-list-item top-distribution-list">
          <div class="label">
            Top Region
          </div>
          <div class="value">
            <ng-container *ngIf="!isFreemium">
              <div class="top-item-label">{{topRegion?.region === 'NA' ? 'North America' : topRegion?.region}}</div>
              <div class="big-number" enAnonLock>{{topRegion?.totalInventoryRatio | perc: '1.2-2'}}</div>
            </ng-container>
            <ng-container *ngIf="isFreemium">
              <div class="top-item-label">{{topRegion?.region === 'NA' ? 'North America' : topRegion?.region}}</div>
              <div class="freemium-lock">
                <i class="fa fa-lock"></i>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="isFreemium || data?.inventoryDistribution?.adSizes?.length > 0">
        <div class="divider mt-32px mb-24px"></div>
        <div class="d-flex info-list-item top-distribution-list">
          <div class="label">
            Top Ad Size
          </div>
          <div class="value">
            <ng-container *ngIf="!isFreemium">
              <div class="top-item-label">{{topAdSize?.adSize}}</div>
              <div class="big-number" enAnonLock>{{topAdSize?.totalInventoryRatio | perc: '1.2-2'}}</div>
            </ng-container>
            <ng-container *ngIf="isFreemium">
              <div class="top-item-label">{{topAdSize?.adSize}}</div>
              <div class="freemium-lock">
                <i class="fa fa-lock"></i>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="isFreemium || dmas.length > 0">
        <div class="divider mt-32px mb-24px"></div>
        <div class="d-flex info-list-item top-distribution-list">
          <div class="label">
            Top DMA
          </div>
          <div class="value">
            <ng-container *ngIf="!isFreemium">
              <div class="top-item-label">{{topDma?.name}}</div>
              <div class="big-number" enAnonLock>{{topDma?.totalInventoryRatio | perc: '1.2-2'}}</div>
            </ng-container>
            <ng-container *ngIf="isFreemium">
              <div class="top-item-label">{{topDma?.name}}</div>
              <div class="freemium-lock">
                <i class="fa fa-lock"></i>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>

    </div>
  </div>
  <div class="col-lg-8">
    <div class="container-fluid pl-0 info-list">
      <ng-container *ngIf="data?.inventoryDistribution?.devices?.length > 0">
        <h3 class="sub-title" id="inventory-devices-cont">
          <img src="/assets/images/icon-market-area.svg" alt="Market Area Icon" />
          Inventory by Devices
          <a class="btn btn-link p-0" data-toggle="tooltip"
            title="The estimated volume of programmatic ad impressions broken down by device.">
            <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
          </a>
        </h3>
        <app-data-table-component [headers]="headerDevices" currentSort="totalInventoryRatio" [data]="devices"
          [limit]="showMoreLimit" (itemClick)="goTo($event)"></app-data-table-component>
      </ng-container>
      <ng-container *ngIf="data?.inventoryDistribution?.regions?.length > 0">
        <h3 class="sub-title mt-32px">
          <img src="/assets/images/icon-region.svg" alt="Region Icon" />
          Inventory by Region
          <a class="btn btn-link p-0" data-toggle="tooltip"
            title="The estimated volume of programmatic ad impressions broken down by business region.">
            <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
          </a>
        </h3>
        <app-data-table-component [headers]="headerRegions" currentSort="totalInventoryRatio" [data]="regions"
          [limit]="showMoreLimit" (itemClick)="goTo($event)"></app-data-table-component>
      </ng-container>
      <ng-container *ngIf="data?.inventoryDistribution?.countries?.length > 0">
        <h3 class="sub-title mt-32px">
          <img src="/assets/images/icon-market-area.svg" alt="Market Area Icon" />
          Inventory by Country
          <a class="btn btn-link p-0" data-toggle="tooltip"
            title="The estimated volume of ad impressions offered by the app over programmatic advertising platforms and exchanges.">
            <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
          </a>
        </h3>
        <app-data-table-component [headers]="headerCountries" currentSort="totalInventoryRatio" [data]="countries"
          [limit]="showMoreLimit" (itemClick)="goTo($event)"></app-data-table-component>
      </ng-container>
      <ng-container *ngIf="region === 'NA' && data?.inventoryDistribution?.states?.length > 0">
        <h3 class="sub-title mt-32px">
          <img src="/assets/images/icon-market-area.svg" alt="Market Area Icon" />
          Inventory by State
          <a class="btn btn-link p-0" data-toggle="tooltip"
            title="The estimated volume of programmatic ad impressions broken down by US State and Canadian Province">
            <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
          </a>
        </h3>
        <app-data-table-component [headers]="headerStates" currentSort="totalInventoryRatio" [data]="states"
          [limit]="showMoreLimit" (itemClick)="goTo($event)"></app-data-table-component>
      </ng-container>
      <ng-container *ngIf="data?.inventoryDistribution?.adSizes?.length > 0">
        <h3 class="sub-title mt-32px" id="inventory-ad-sizes-cont">
          <img src="/assets/images/icon-ad-sizes.svg" alt="AdSize Icon" />
          Inventory by Ad Size
          <a class="btn btn-link p-0" data-toggle="tooltip"
            title="The estimated volume of programmatic ad impressions broken down by ad size">
            <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
          </a>
        </h3>
        <app-data-table-component [headers]="headerAdSizes" currentSort="totalInventoryRatio"
          [data]="adSizes"></app-data-table-component>
      </ng-container>
      <ng-container *ngIf="dmas?.length > 0">
        <h3 class="sub-title mt-32px">
          <img src="/assets/images/icon-market-area.svg" alt="Market Area Icon" />
          Inventory by DMA
          <a class="btn btn-link p-0" data-toggle="tooltip"
            title="The estimated volume of programmatic ad impressions broken down by Designated Market Area (DMA)">
            <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
          </a>
        </h3>
        <app-data-table-component [headers]="headerDmas" currentSort="totalInventoryRatio"
          [data]="dmas"></app-data-table-component>
      </ng-container>
      <ng-container *ngIf="data?.user?.byMonth?.length > 0">
        <h3 class="sub-title mt-32px" id="inventory-users-cont">
          <img src="/assets/images/icon-users-grey.svg" alt="User Icon" />
          Inventory by Users
          <a class="btn btn-link p-0" data-toggle="tooltip" title="">
            <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
          </a>
        </h3>
        <ng-container *ngIf="!isFreemium">
          <app-line-chart [data]="lineChartData" [titleArray]="['Est. Daily Reach', 'Est. Monthly Reach']"
            [height]="'500px'" [type]="'double'" [categoryField]="'month'"
            [valueFields]="['dailyActiveUsers','monthlyActiveUsers']"></app-line-chart>
        </ng-container>
        <ng-container *ngIf="isFreemium">
          <div class="freemium-lock">
            <i class="fa fa-lock"></i>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #regionTemplate let-item='item' let-row='row'>
  <span>{{ item === 'NA' ? 'North America' : item }}</span>
</ng-template>

<ng-template #lockedTemplate>
  <i class="fa fa-lock"></i>
</ng-template>

<ng-template #percentFormattedTemplate let-item='item'>
  <span>{{ item < 0.01 ? "< 1%" : item | perc:'1.2-2' }}</span>
</ng-template>

<ng-template #countryTemplate let-item='item' let-row='row'>
  <img *ngIf="row.country" class="dropdown-item-flag"
    src="https://cdn.pixalate.com/icons/countries/flat/48/{{ row.country }}.png"
    alt="{{ row.country }} Flag Icon" /><span> {{ item }}</span>
</ng-template>